import { createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL_V2, STORE_BASE_PATH } from '../../common/constants';
import { baseQueryWithReauth } from './baseQueryWithReauth';

export const facadeApiV2 = createApi({
    reducerPath: `${STORE_BASE_PATH}facadeApiV2`,
    baseQuery: baseQueryWithReauth(BASE_URL_V2),
    endpoints: () => ({}),
});
